import {Grid, GridItem} from "@consta/uikit/Grid";
import {Button} from "@consta/uikit/Button";
import React, {useEffect, useState} from "react";
import "../css/pageEquipage.css";
import {DragNDropField} from '@consta/uikit/DragNDropField';
import {Text} from '@consta/uikit/Text';
import GridBsiBsiList from "./component/grid.bsi.bsiList";
import ModalBsiPayload, {readFile} from "./component/modal.bsi.payload";
import ModalBsiDiagram from "./component/modal.bsi.diagram";
import {Tabs} from "@consta/uikit/Tabs";
import {IconPhoto} from "@consta/uikit/IconPhoto";
import {IconRing} from "@consta/uikit/IconRing";
import {IconComponent} from "@consta/uikit/Icon";
import {SnackCmp} from "../../component/snack.cmp";
import {ProcessingType} from "./component/modal.bsi.payload";

type Item = {
    name: string;
    image?: IconComponent;
};

const items: Item[] = [
    {
        name: "Загрузка",
        image: IconPhoto
    },
    {
        name: "Сервер",
        image: IconRing
    }
];

const PageBsi = () => {
    const [tabsValue, setTabsValue] = useState<Item | null>(items[0]);
    const [files, setFiles] = React.useState<File[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDiagramOpen, setIsModalDiagramOpen] = useState(false);
    const [newRowData, setNewRowData] = useState<any>(null);
    const [bsiFileDiagram, setBsiFileDiagram] = useState<string | null>();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [processingData, setProcessingData] = useState<ProcessingType[]>([]);

    useEffect(() => {
        document.title = 'АСПО.Контроль | БСИ';
    }, []);

    const handleModalClose = (value: any) => {
        setIsModalOpen(false);
        if (value && value !== false) {
            // value теперь это processingData (массив)
            if (Array.isArray(value) && value.length > 0) {
                setProcessingData(value);
                setShowSnackbar(true);
                setNewRowData(value); // Обновляем данные для таблицы

                // Скрываем снекбар через 4 секунды после последнего уведомления
                setTimeout(() => {
                    setShowSnackbar(false);
                    setProcessingData([]);
                }, 4000);
            }
        }
    };

    const handleDropFiles = (files: any) => {
        setFiles(files)
        setIsModalOpen(true)
    }

    const handleDropFilesDiagram = (files: any) => {
        readFile(files[0])
            .then((contents: any) => {
                setBsiFileDiagram(contents)
            })
        setIsModalDiagramOpen(true)
    }

    const handleModalDiagramClose = () => {
        setIsModalDiagramOpen(false);
        setBsiFileDiagram(null)
    };


    return (
        <>
            <Tabs
                value={tabsValue}
                size="m"
                view="bordered"
                linePosition="bottom"
                fitMode="scroll"
                onChange={({value}) => setTabsValue(value)}
                items={items}
                getItemLabel={(item) => item.name}
            />
            {tabsValue?.name === "Загрузка" &&
                (<Grid className="gridMain" cols="4" gap="xs">
                    <GridItem col={2}>
                        <DragNDropField multiple={true}
                                        onDropFiles={(files) => handleDropFiles(files)}
                                        accept={['.txt']}>
                            {({openFileDialog}) => (
                                <>
                                    <Text weight="black">
                                        Загрузка БСИ
                                    </Text>
                                    <Text>
                                        Перетащите сюда БСИ-файл экипажа или выберите его нажав на кнопку.
                                    </Text>
                                    <br/>
                                    <Button size='s' onClick={openFileDialog} label="Выбрать файл"/>
                                </>
                            )}
                        </DragNDropField>
                    </GridItem>
                    <GridItem col={2}>
                        <DragNDropField multiple={false}
                                        onDropFiles={(files) => handleDropFilesDiagram(files)}
                                        accept={['.txt']}>
                            {({openFileDialog}) => (
                                <>
                                    <Text weight="black">
                                        Просмотр диаграммы
                                    </Text>
                                    <Text>
                                        Перетащите сюда БСИ-файл экипажа или выберите его нажав на кнопку.
                                    </Text>
                                    <br/>
                                    <Button size='s' onClick={openFileDialog} label="Выбрать файл"/>
                                </>
                            )}
                        </DragNDropField>
                    </GridItem>
                    <GridItem col={4}>
                        <GridBsiBsiList key="uploaded" newRowData={newRowData} fromUploaded={false}/>
                    </GridItem>
                </Grid>)}

            {tabsValue?.name === "Сервер" &&
                <Grid className="gridMain" cols="4" gap="xs">
                    <GridItem col={4}>
                        <GridBsiBsiList key="server" newRowData={newRowData} fromUploaded={true}/>
                    </GridItem>
                </Grid>
            }

            <ModalBsiPayload isOpen={isModalOpen}
                             onClose={handleModalClose}
                             files={files}
                             nodeData={null}/>
            {bsiFileDiagram && <ModalBsiDiagram isOpen={isModalDiagramOpen}
                                                onClose={handleModalDiagramClose}
                                                bsiFileDiagram={bsiFileDiagram}
            />}

            {showSnackbar && processingData.length > 0 && (
                <SnackCmp
                    key={JSON.stringify(processingData)}
                    alertText={''}
                    processingData={processingData}
                    alertType={'normal'}
                />
            )}
        </>
    )
}

export default PageBsi;